import React from "react";
import { useTranslation } from "react-i18next";
import Container from "react-bootstrap/Container";

import { Title } from "./common/Title";
import styles from "../assets/styles/about.module.scss";

import aboutImage1 from "../assets/images/about-1.jpg";
import aboutImage2 from "../assets/images/about-2.jpg";
import aboutImage3 from "../assets/images/about-3.jpg";

export function About() {
  const { t, i18n } = useTranslation("about");

  return (
    <section className={styles.about} id="about">
      <Container data-aos="fade-up" data-aos-delay="100">
        <div className="mb-5">
            <div className="rounded">
              <Title title={t("title")} />
              <div className="text-justify mb-5 fs-4">{t("about")}</div>
              <div className="d-flex flex-lg-row flex-md-column flex-sm-column flex-column gap-4 text-center">
                <div><img className="img-fluid" alt={t("clinic")} src={aboutImage3} /></div>
                <div><img className="img-fluid" alt={t("clinic")} src={aboutImage1} /></div>
                <div><img className="img-fluid" alt={t("clinic")} src={aboutImage2} /></div>
              </div>
            </div>
          </div>
      </Container>
    </section>
  );
}